import React, { useState, useEffect } from "react";
import Button from "./Button";
import AlertBox from "./AlertBox";
import { useStateContext } from "../contexts/ContextProvider";
import { FaRegTrashAlt } from "react-icons/fa";
import { apiDeleteChore, apiUpdateChore } from "../services/apiService";

const initialErrorState = {
  choreName: "",
  choreDesc: "",
  frequency: "",
  rooms: "",
};
//TODO: add error handling for form

const descLength = 300;

const EditChoreModal = (props) => {
  const { choreId, currentChore } = props;
  const { rooms, leases, chores, setChores, handleModal, alert, handleAlert } =
    useStateContext();
  const [chore, setChore] = useState(currentChore);
  const [error, setError] = useState(initialErrorState);
  const [count, setCount] = useState(descLength - chore.choreName.length);

  let initialCheckboxStates = {};

  // const currentPropertyRooms = rooms.filter(
  //   (x) => x.propertyId === chore.propertyId
  // );

  const currentPropertyLeases = leases.filter(
    (x) => x.propertyId === chore.propertyId
  );

  // currentPropertyRooms.forEach((x) => {
  //   initialCheckboxStates[x.id] = {
  //     id: x.id,
  //     roomName: x.roomName,
  //     isSelected: chore.roomIds.find((y) => y === x.id) ? true : false,
  //   };
  // });

  currentPropertyLeases.forEach((x) => {
    initialCheckboxStates[x.id] = {
      id: x.id,
      roomName: x.roomName,
      isSelected: true,
    };
  });

  // const [selectedRooms, setSelectedRooms] = useState(initialCheckboxStates);
  const [selectedLeases, setSelectedLeases] = useState(initialCheckboxStates);

  useEffect(() => {
    // Update rooms array
    let leasesArr = [];
    Object.entries(selectedLeases).forEach(([key, value]) => {
      if (value.isSelected) leasesArr.push(value.id);
    });
    setChore((prevState) => ({ ...prevState, leaseIds: leasesArr }));
  }, [selectedLeases]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setChore((prevState) => ({ ...prevState, [name]: value }));
    if (name === "choreDesc") setCount(descLength - value.length);
  };

  const handleChecked = (event) => {
    const { id, checked } = event.target;

    setSelectedLeases((prevState) => ({
      ...prevState,
      [id]: { ...prevState[id], isSelected: checked },
    }));
  };

  const updateChore = async () => {
    // updateChore route
    const response = await apiUpdateChore(chore.id, chore);
    if (response.hasError) {
      // TODO: add error message
      return;
    } else {
      setChores(
        chores.toSpliced(
          chores.findIndex((x) => x.id === chore.id),
          1,
          response.data
        )
      );
      handleModal("editChore");
    }
  };

  const deleteChore = async () => {
    // deleteChore route
    const response = await apiDeleteChore(chore.id);
    if (response.hasError) {
      //TODO: add error message
      return;
    } else {
      setChores(
        chores.toSpliced(
          chores.findIndex((x) => x.id === chore.id),
          1
        )
      );
      handleModal("editChore");
    }
  };

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      {alert.deleteChore && (
        <AlertBox
          alertType="deleteChore"
          handleAlert={handleAlert}
          alertFunc={() => {
            deleteChore();
          }}
        />
      )}
      <div className="flex justify-center mt-5">Edit Chore {chore.id}</div>
      <form
        className="grid justify-items-center"
        onSubmit={(e) => {
          e.preventDefault();
          updateChore();
        }}
      >
        <label className={`grid mt-5 ${error.choreName}`}>
          <div>
            Chore Name: <span className="text-red-500">*</span>
          </div>
          <input
            id="chore-name"
            name="choreName"
            type="text"
            maxLength={60}
            placeholder="Name"
            value={chore.choreName}
            autoFocus={true}
            className={`w-72 border-gray-300 border-1 rounded-md p-1 ${error.choreName}`}
            onChange={handleChange}
          />
        </label>
        <label className={`grid mt-5 ${error.choreDesc}`}>
          <div>
            What does this chore consist of?{" "}
            <span className="text-red-500">*</span>
          </div>
          <textarea
            id="chore-desc"
            name="choreDesc"
            type="text"
            maxLength={descLength}
            placeholder="Description"
            value={chore.choreDesc}
            className={`w-72 h-40 border-gray-300 border-1 p-1 ${error.choreDesc}`}
            onChange={handleChange}
          />
          <div
            className={`flex justify-end ${
              count === 0 ? "animate-shake text-red-600" : ""
            }`}
          >
            {count}
          </div>
        </label>
        <label className="grid">
          Frequency
          <select
            id="frequency"
            name="frequency"
            value={chore.frequency}
            className={`w-72 border-gray-300 border-1 ${error.frequency}`}
            onChange={handleChange}
            onChangeCapture={() => console.log("change complete")}
          >
            <option disabled>--</option>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="bi-weekly">Every Other Week</option>
            <option value="monthly">Monthly</option>
          </select>
        </label>
        <label
          className={`grid justify-items-center mt-5 mb-5 px-10 ${error.rooms}`}
        >
          Participants:
          <ul className="grid grid-cols-2 gap-x-10 gap-y-1 mt-2">
            {currentPropertyLeases.map((item, index) => {
              return (
                <li
                  key={item.id}
                  className={`flex justify-between ${error.rooms}`}
                >
                  <div>{item.roomName}: </div>
                  <input
                    id={item.id}
                    name={item.roomName}
                    type="checkbox"
                    checked={selectedLeases[item.id].isSelected}
                    className="h-5 w-5"
                    onChange={handleChecked}
                  />
                </li>
              );
            })}
          </ul>
        </label>
      </form>
      <div
        className="flex justify-center items-center text-red-500 hover:text-red-700 mt-3 gap-x-2"
        onClick={() => handleAlert("deleteChore")}
      >
        <FaRegTrashAlt /> Delete
      </div>
      <div className="flex justify-center fixed bottom-0 w-full my-10">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Cancel"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("editChore")}
        />
        <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Update"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={updateChore}
        />
      </div>
    </div>
  );
};

export default EditChoreModal;
